const isLocal =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const defaultBackendUrl = isLocal
  ? 'http://localhost:5002'
  : 'https://indianhospitalitynetwork.com';

const envApiUrl = trimTrailingSlash(process.env.REACT_APP_API_URL);
const envBackendUrl = trimTrailingSlash(process.env.REACT_APP_BACKEND_URL);

export const BACKEND_URL =
  envBackendUrl || (envApiUrl.endsWith('/api') ? envApiUrl.slice(0, -4) : envApiUrl) || defaultBackendUrl;

export const API_URL =
  envApiUrl || `${BACKEND_URL}/api`;

export const FRONTEND_URL = isLocal
  ? 'http://localhost:3000'
  : 'https://indianhospitalitynetwork.com';

export default API_URL;
